export default {
  noData: 'Brak danych do porównania',
};
